/**
 * Category Icon Component
 * Maps category icon names to Lucide React icons
 */

import {
  Building2,
  ArrowLeftRight,
  Shuffle,
  LineChart,
  Blocks,
  Coins,
  Bitcoin,
  CreditCard,
  Gift,
  UserCheck,
  Bell,
  Building,
  ShoppingCart,
  Calculator,
  FileText,
  HelpCircle,
  LucideIcon,
} from 'lucide-react';

// Icon mapping
const iconMap: Record<string, LucideIcon> = {
  Building2,
  ArrowLeftRight,
  Shuffle,
  LineChart,
  Blocks,
  Coins,
  Bitcoin,
  CreditCard,
  Gift,
  UserCheck,
  Bell,
  Building,
  ShoppingCart,
  Calculator,
  FileText,
};

interface CategoryIconProps {
  iconName: string;
  className?: string;
  size?: number;
}

export function CategoryIcon({ iconName, className, size = 16 }: CategoryIconProps) {
  const Icon = iconMap[iconName] || HelpCircle;
  return <Icon className={className} size={size} />;
}

export default CategoryIcon;
